export default "__VITE_ASSET__DHyMYQk___"